// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__+7UGN","burger__pressed":"Burger_burger__pressed__HsdXV","burger__up":"Burger_burger__up__trE+w","border_background":"Burger_border_background__-Nx5K"};